
      function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFibersIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 93,
  height: 132,
  viewBox: "0 0 31.707 45.228"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M43.741 17.639a4.666 4.666 0 1 0-4.666-4.666 4.952 4.952 0 0 0 .762 2.618 30.227 30.227 0 0 0-3.951 10.759h-1.809V11.593a4.666 4.666 0 1 0-2.952 0V26.3h-1.9a30.6 30.6 0 0 0-3.951-10.759 4.829 4.829 0 0 0 .762-2.618 4.666 4.666 0 1 0-4.666 4.666 4.727 4.727 0 0 0 1.428-.238 28.62 28.62 0 0 1 3.333 8.9h-1.623a1.534 1.534 0 0 0-1.523 1.523V32.3h-.715a1.5 1.5 0 0 0-1.523 1.523V46.2a1.523 1.523 0 0 0 3.047 0V35.349h17.472V46.2a1.523 1.523 0 0 0 3.047 0V33.826a1.5 1.5 0 0 0-1.524-1.526h-.714v-4.52a1.534 1.534 0 0 0-1.523-1.523h-1.619a26.414 26.414 0 0 1 3.333-8.9 3.88 3.88 0 0 0 1.475.282zM30.887 7.166a1.666 1.666 0 1 1 1.666 1.666 1.656 1.656 0 0 1-1.666-1.666zm-9.521 7.474a1.666 1.666 0 1 1 1.666-1.666 1.687 1.687 0 0 1-1.666 1.666zm17.71 17.66H26.031v-3h13.045zm4.666-21a1.666 1.666 0 1 1-1.666 1.666 1.687 1.687 0 0 1 1.665-1.659z",
  transform: "translate(-16.7 -2.5)",
  style: {
    fill: "var(--theme-primary, #810ea9)"
  }
}));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"93\" height=\"132\" viewBox=\"0 0 31.707 45.228\">\r\n    <path d=\"M43.741 17.639a4.666 4.666 0 1 0-4.666-4.666 4.952 4.952 0 0 0 .762 2.618 30.227 30.227 0 0 0-3.951 10.759h-1.809V11.593a4.666 4.666 0 1 0-2.952 0V26.3h-1.9a30.6 30.6 0 0 0-3.951-10.759 4.829 4.829 0 0 0 .762-2.618 4.666 4.666 0 1 0-4.666 4.666 4.727 4.727 0 0 0 1.428-.238 28.62 28.62 0 0 1 3.333 8.9h-1.623a1.534 1.534 0 0 0-1.523 1.523V32.3h-.715a1.5 1.5 0 0 0-1.523 1.523V46.2a1.523 1.523 0 0 0 3.047 0V35.349h17.472V46.2a1.523 1.523 0 0 0 3.047 0V33.826a1.5 1.5 0 0 0-1.524-1.526h-.714v-4.52a1.534 1.534 0 0 0-1.523-1.523h-1.619a26.414 26.414 0 0 1 3.333-8.9 3.88 3.88 0 0 0 1.475.282zM30.887 7.166a1.666 1.666 0 1 1 1.666 1.666 1.656 1.656 0 0 1-1.666-1.666zm-9.521 7.474a1.666 1.666 0 1 1 1.666-1.666 1.687 1.687 0 0 1-1.666 1.666zm17.71 17.66H26.031v-3h13.045zm4.666-21a1.666 1.666 0 1 1-1.666 1.666 1.687 1.687 0 0 1 1.665-1.659z\" transform=\"translate(-16.7 -2.5)\" style=\"fill:var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/fibers-icon.252b25512ceb16b64a0504d76c65af6d.svg"),
        {
          React: SvgFibersIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      